import CategoryPage from './category.container';

export default CategoryPage;